<div *ngIf="isLoading" class="cdc-loading-overlay">
  <mat-spinner class="cdc-loading-spinner"></mat-spinner>
  <div class="cdc-loading-text">{{ 'Loading' | translate }}</div>
</div>
